import {ApplicationRef, Injectable} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';

@Injectable({
    providedIn: 'root'
})
export class SwUpdateService {
    constructor(private appRef: ApplicationRef, private updates: SwUpdate) {}

    public async init(): Promise<void> {
        try {
            const updateFound = await this.updates.checkForUpdate();
            console.log(updateFound ? 'SW: new version is available.' : 'SW: already on the latest version.');
            if (updateFound) {
                this.updates.versionUpdates.subscribe(evt => {
                    switch (evt.type) {
                        case 'VERSION_DETECTED':
                            console.log(`SW: downloading new app version: ${evt.version.hash}`);
                            break;
                        case 'VERSION_READY':
                            console.log(`SW: new app version ready for use: ${evt.latestVersion.hash}`);
                            // document.location.reload();
                            break;
                        case 'VERSION_INSTALLATION_FAILED':
                            console.log(`SW: failed to install app version '${evt.version.hash}': ${evt.error}`);
                            break;
                        case 'NO_NEW_VERSION_DETECTED':
                            console.log(`SW: not a new version detected ${evt.version.hash}`);
                            break;
                    }
                });
            }
        } catch (err) {
            console.error('Failed to check for updates:', err);
        }
    }
}
